import { useEffect } from "react";
import useHistory from "routing/useHistory";
import Routes from "integrations/aws/common/Routes";
const AWSInputConfiguration = ({ url = Routes.INTEGRATIONS.AWS.CLOUDWATCH.index }) => {
  const { push } = useHistory();
  useEffect(() => {
    push(url);
  }, [url, push]);
  return null;
};
export default AWSInputConfiguration;
